import TagRepositoryInterface, { TagInterface } from '@/services/QA/tag/interfaces';
import { AxiosInstance } from 'axios';

export default class TagRepository implements TagRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async createTag(data: Partial<TagInterface>): Promise<TagInterface> {
    const res = await this.axios.post('/qa-controller/tags', data);

    return res.data;
  }

  public async editTag(tagId: number, tagData: Partial<TagInterface>): Promise<void> {
    await this.axios.patch(`/qa-controller/tags/${tagId}`, tagData);
  }

  public async getOneById(tagId: number): Promise<TagInterface> {
    const res = await this.axios.get(`/qa-controller/tags/${tagId}`);

    return res.data;
  }

  public async getActiveTags(): Promise<TagInterface[]> {
    const res = await this.axios.get('/qa-controller/tags');

    return res.data;
  }

  public async getAllTags(): Promise<TagInterface[]> {
    const res = await this.axios.get('/qa-controller/tags/all');

    return res.data;
  }

  public async deleteTag(tagId: number): Promise<void> {
    await this.axios.delete(`/qa-controller/tags/${tagId}`)
  }
}
